/**
 * DOCS/shows/image.png — a single solid ticket-shaped shimmer block (same
 * concave-notch corners as a real `.shows-card`, no separate image/title/
 * description sub-regions inside it), not a multi-line "image + text bars"
 * skeleton. `shows-card-skeleton` (shows.css) supplies the shimmer-sweep
 * animation and a fixed height matching a real rendered card (~448px at
 * typical content length) so the grid doesn't jump once real cards land.
 */
export function ShowCardSkeleton() {
  return <div className="shows-card shows-card-skeleton" aria-hidden />;
}
